import React, { memo } from "react";
import useViewport from "~/assets/js/Helpers/hooks/useViewport";
import GalleryDesktop from "./Desktop";
import GalleryMobile from "./Mobile";
import { imagesType } from "./type";

const Gallery = ({ images, backLink }) => {
    const { isDesktop } = useViewport();

    return (
        <div id="gallery" className={isDesktop ? "" : "container"}>
            {isDesktop ? (
                <GalleryDesktop images={images} />
            ) : (
                <GalleryMobile images={images} backLink={backLink} />
            )}
        </div>
    );
};

Gallery.propTypes = imagesType;

export default memo(Gallery);
